import { Injectable } from '@angular/core';
import {Session} from "../../shared/models/session";
import {BehaviorSubject, Subject} from "rxjs";
import {AngularFireAuth} from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';
import 'firebase/auth';
import {Router} from '@angular/router';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import GoogleAuthProvider = firebase.auth.GoogleAuthProvider;
import {Account} from "../../shared/models/account";
import {Message} from "../../shared/models/message";
import {MessageService} from "./message.service";
import {AngularFireFunctions} from "@angular/fire/compat/functions";
import UserCredential = firebase.auth.UserCredential;
import {COLLECTION_NAME, logError} from "../../shared/constants";

interface StringKeyObject {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  public session = new Session();
  public sessionSubject = new Subject<Session>(); // 追加
  public sessionBehaviorSubject = new BehaviorSubject<Session>(this.session);
  public sessionState = this.sessionSubject.asObservable(); // 追加

  constructor(private db: AngularFirestore,
              private afAuth: AngularFireAuth,
              private afn: AngularFireFunctions,
              private router: Router,
              private messageService: MessageService) {
    this.afAuth.idToken.subscribe(token => {
      this.session.token = token ?? '';
      this.sessionSubject.next(this.session);
    });
    this.afAuth.idTokenResult.subscribe(idTokenResult2 => {
      if (!idTokenResult2) return;
      const claims = idTokenResult2.claims;
      for (const key in claims) {
        if (claims.hasOwnProperty(key)) {
          (this.session as StringKeyObject)[key] = !!claims[key];
          if (!!claims[key]) console.log(key, 'is true');
        }
      }
    });
    this.afAuth.onAuthStateChanged(user => {
      if (!user) return;
      this.session.login = true;
      this.session.user = user;
      this.sessionSubject.next(this.session);
      this.db.collection(COLLECTION_NAME.USERS).doc(this.session.user.email).valueChanges()
        .subscribe(personalSetting => {
          this.session.personalSetting = personalSetting;
          this.sessionBehaviorSubject.next(this.session);
          console.log('authed: constructor');
        });
    });
  }

  next(): void {
    this.sessionSubject.next(this.session);
    this.sessionBehaviorSubject.next(this.session);
  }

  loginWithEmailAndPassword(password: Account): void {
    this.session.loading = true;
    this.afAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        this.afAuth
          .signInWithEmailAndPassword(password.email.toLowerCase(), password.password)
          .then(this.loginCallback)
          .catch(this.errorCallback);
      });
  }

  login(): void {
    this.session.loading = true;
    // 変更
    // @ts-ignore
    this.afAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        const provider = new GoogleAuthProvider();
        this.afAuth
          .signInWithPopup(provider)
          .then(this.loginCallback)
          .catch(this.errorCallback);
      });
  }

  loginCallback = (auth: UserCredential) => {
    if (!auth.user?.emailVerified) {
      this.afAuth.signOut().then(() => {
        // location.reload();
      });
    }
    this.afAuth.idToken.toPromise().then(token => this.session.token = token ?? '');
    this.session.login = true;
    this.session.user = auth.user;
    this.sessionSubject.next(this.session);
    this.sessionBehaviorSubject.next(this.session);
    this.session.loading = false;
    // await this.appInitService.Init();
    return this.router.navigate(['/']);
  }

  errorCallback = (err: any) => {
    const message = new Message();
    message.type = 'error';
    if (err.code === 'auth/user-not-found') {
      message.message = '権限がありません。';
    } else if (err.code === 'auth/wrong-password') {
      message.message = 'パスワードが正しくありません。';
    } else {
      message.message = 'ログインに失敗しました。';
    }
    if (!!err.code) {
      this.messageService.messageSubject.next(message);
    }
  }

  doAuth = async () => {
    return new Promise(resolve => {
      this.afAuth.onAuthStateChanged(user => {
        if (!user) { return resolve(user);}
        this.session.login = true;
        this.session.user = user;
        this.sessionSubject.next(this.session);
        this.db.collection(COLLECTION_NAME.USERS).doc(this.session.user.email).valueChanges()
          .subscribe(personalSetting => {
            this.session.personalSetting = personalSetting;
            this.sessionBehaviorSubject.next(this.session);
            console.log('authed: doAuth');
            resolve(user);
          });
      });
    });
  };

  // doLogin = async () => {
  //   // @ts-ignore
  //   return this.afAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  //     .then(() => {
  //       const provider = new GoogleAuthProvider();
  //       return this.afAuth
  //         .signInWithPopup(provider);
  //     })
  //     .then(auth => {
  //       if (!auth.user?.emailVerified) {
  //         this.afAuth.signOut().then(() => {
  //           location.reload();
  //         });
  //       }
  //       // this.afAuth.idToken.toPromise().then((token: string) => {
  //       //   this.session.token = token;
  //       // });
  //       this.session.login = true;
  //       this.session.user = auth.user.email;
  //       // this.session.domain = auth.user.email.split('@')[1];
  //       this.sessionSubject.next(this.session);
  //       this.session.loading = false;
  //       return this.router.navigate(['/']);
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       // const message = new Message();
  //       // message.type = 'error';
  //       // message.message = 'ログインに失敗しました';
  //       // this.messageService.messageSubject.next(message);
  //       // this.session.loading = false;
  //     });
  // };

  logout(): void {
    const email = this.session.personalSetting.mail;
    this.afAuth
      .signOut()
      .then(() => {
        this.session.reset();
        this.sessionSubject.next(this.session);
        console.log('logout', email);
        return this.router.navigate(['/auth/login'], { queryParams: { email: email } });
      })
      .then(() => this.session.loading = false)
      .catch((err: any) => {
        console.log(err);
      });
  }

  sendPasswordResetEmail(passwordResetEmail: string): void {
    this.afn.httpsCallable('authentication-authentication-sendPasswordResetEmail')(passwordResetEmail.toLowerCase())
      .toPromise().then(() => {
        const message = new Message();
        message.type = 'info';
        message.message = 'パスワード再設定メールを送信しました。';
        this.messageService.messageSubject.next(message);
      })
      .catch(logError);
  }
}
